import { useEffect } from "react";
import { useUIStore } from "../store/uiStore";

// Show a one-time welcome toast per key; allow suppression per user (local) or session
export const useWelcomeOnce = (key, message) => {
  const { pushToast } = useUIStore();
  useEffect(() => {
    try {
      const suppressed =
        localStorage.getItem(`welcome_suppress_${key}`) === "1";
      if (suppressed) return;
      const flag = sessionStorage.getItem(`welcome_${key}`);
      if (!flag) {
        pushToast(message || "Welcome!", "info", 4000, {
          actionLabel: "Don't show again",
          onAction: () => {
            try {
              localStorage.setItem(`welcome_suppress_${key}`, "1");
            } catch {}
          },
          ariaLabel: "Welcome tip",
        });
        sessionStorage.setItem(`welcome_${key}`, "1");
      }
    } catch {}
  }, [key, message, pushToast]);
};

export default useWelcomeOnce;
